module.exports = "<chassis-core-list-widget [(items)]=\"users\" [options]=\"options\" [(loader)]=\"loader\"></chassis-core-list-widget>\n"


//////////////////
// WEBPACK FOOTER
// ./libs/chassis-core/src/app/dashboards/components/user-list-widget/user-list-widget.component.html
// module id = ./libs/chassis-core/src/app/dashboards/components/user-list-widget/user-list-widget.component.html
// module chunks = main